<template>

  <v-container fluid class="pa-0">

    <!--------------------------->
    <!-- Status Count Overview -->
    <!--------------------------->
    <v-container class="mb-2 status-count-container">
      <v-row>
        <!-- <v-col cols="12" xs="12" sm="6" md="3" lg="3">
          <span class="mr-2 status-count-label">Approved:</span>
          <span class="status-count-value">{{ approvedLocationCount }}</span>
        </v-col> -->
        <v-col cols="12" xs="12" sm="6" md="4" lg="4" class="form-field-label d-flex align-center justify-sm-start justify-md-center">
          <span class="mr-2 status-count-label">Pending Approval:</span>
          <span class="status-count-value">{{ pendingApprovalLocations.length }}</span>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" lg="4" class="form-field-label d-flex align-center justify-sm-start justify-md-center">
          <span class="mr-2 status-count-label">Requires Approval:</span>
          <span class="status-count-value">{{ requiresApprovalLocations.length }}</span>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4" lg="4" class="form-field-label d-flex align-center justify-sm-start justify-md-center">
          <span class="mr-2 status-count-label">Requires Setup:</span>
          <span class="status-count-value">{{ requiresSetupLocations.length }}</span>
        </v-col>
      </v-row>
    </v-container>

    <!-------------------->
    <!-- Action List UI -->
    <!-------------------->
    <v-container fluid class="py-4 ma-0 location-sys-admin-notifications">
      <v-row>
        <!---------------------->
        <!-- Pending Approval -->
        <!---------------------->
        <v-col cols="12" xs="12" sm="12" md="6" lg="6">
          <div class="align-center justify-center">
            <div class="d-flex align-center justify-center">
              <v-icon style="font-size:22px;" class="mr-2" color="#FFD600">mdi-clock-check-outline</v-icon>
              <span style="color:#FFD600" class="action-title">Pending Approval</span>
            </div>
            <div class="action-info d-flex align-center justify-center mt-4">
              <div align="center">
                <div v-if="pendingApprovalLocations.length === 1">{{ pendingApprovalLocations.length }} location is awaiting review and approval.</div>
                <div v-else-if="pendingApprovalLocations.length > 1">{{ pendingApprovalLocations.length }} locations are awaiting review and approval.</div>
                <div v-else>(None)</div>
              </div>
            </div>
            <template v-if="pendingApprovalLocations.length > 0">
              <div class="d-flex align-center justify-center mt-3">
                <v-btn text icon color="#d9d9d9" @click="showPendingApproval = !showPendingApproval">
                  <span class="mr-1">Ready to Approve</span>
                  <v-icon v-if="!showPendingApproval">mdi-chevron-down</v-icon>
                  <v-icon v-else>mdi-chevron-up</v-icon>
                </v-btn>
              </div>
              <transition name="fade" appear>
                <div class="mb-4 mt-0 pl-3 more-info-text" v-if="showPendingApproval">
                  <div class="mt-2" v-for="(location, index) in pendingApprovalLocations" :key="`pending-${index}`">
                    <router-link class="item-link" :to="generateLocationPageLink(location)">
                      {{ location.name }}
                    </router-link>
                  </div>
                </div>
              </transition>
            </template>
          </div>
        </v-col>

        <!-------------------->
        <!-- Requires Setup -->
        <!-------------------->
        <v-col cols="12" xs="12" sm="12" md="6" lg="6">
          <div class="align-center justify-center">
            <div class="d-flex align-center justify-center">
              <v-icon style="font-size:22px;" class="mr-2" color="#FF5D67">mdi-alert-circle-outline</v-icon>
              <span style="color:#FF5D67" class="action-title">Requires Setup</span>
            </div>
            <div class="action-info d-flex align-center justify-center mt-4">
              <div align="center">
                <div v-if="requiresSetupLocations.length === 1">{{ requiresSetupLocations.length }} location has not been set up.</div>
                <div v-else-if="requiresSetupLocations.length > 1">{{ requiresSetupLocations.length }} locations have not been set up.</div>
                <div v-else>(None)</div>
              </div>
            </div>
            <template v-if="requiresSetupLocations.length > 0">
              <div class="d-flex align-center justify-center mt-3">
                <v-btn text icon color="#d9d9d9" @click="showRequiresSetup = !showRequiresSetup">
                  <span class="mr-1">Requires Setup</span>
                  <v-icon v-if="!showRequiresSetup">mdi-chevron-down</v-icon>
                  <v-icon v-else>mdi-chevron-up</v-icon>
                </v-btn>
              </div>
              <transition name="fade" appear>
                <div class="mb-4 mt-0 pl-3 more-info-text" v-if="showRequiresSetup">
                  <div class="mt-2" v-for="(location, index) in requiresSetupLocations" :key="`setup-${index}`">
                    <router-link class="item-link" :to="generateLocationPageLink(location)">
                      {{ location.name }}
                    </router-link>
                  </div>
                </div>
              </transition>
            </template>
          </div>
        </v-col>
      </v-row>
    </v-container>

  </v-container>

</template>

<script>
export default {
  name: 'LocationSysAdminNotifications',

  props: {
    locationType: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      showPendingApproval: false,
      showRequiresSetup: false,
      isDataLoading: false,
      dataLoadingError: null,
      locationData: null
    }
  },

  computed: {
    appName () {
      return this.$store.getters['app/platform']
    },
    pendingApprovalLocations () {
      return (this.locationData)
        ? this.locationData.items.filter(it => it[`${this.locationType}_status`] === 'PENDING_APPROVAL')
        : []
    },
    requiresApprovalLocations () {
      return (this.locationData)
        ? this.locationData.items.filter(it => it[`${this.locationType}_status`] === 'REQUIRES_APPROVAL')
        : []
    },
    requiresSetupLocations () {
      return (this.locationData)
        ? this.locationData.items.filter(it => it[`${this.locationType}_status`] === 'REQUIRES_SETUP')
        : []
    },
    approvedLocationCount () {
      return ''
    }
  },

  async beforeMount () {
    this.loadLocations()
  },

  methods: {
    // Generate link data for location page
    generateLocationPageLink (item) {
      if (item && item.model) {
        const linkData = {
          name: `${this.locationType}-item`,
          params: {}
        }
        linkData.params[`${this.locationType}Id`] = item.id
        return linkData
      } else {
        return ''
      }
    },

    async loadLocations () {
      try {
        this.isDataLoading = true

        const uri = `${this.locationType}s`
        const params = {}
        params[`${this.locationType}_status`] = ['PENDING_APPROVAL', 'REQUIRES_APPROVAL', 'REQUIRES_SETUP']

        this.locationData = await this.$store.dispatch('sh/dataApi', {
          method: 'get',
          uri,
          opts: { params }
        })
      } catch (err) {
        this.dataLoadingError = err.message || err.text || err
      } finally {
        this.isDataLoading = false
      }
    }
  }
}
</script>

<style scoped>
  .status-count-container {
    font-size: 0.9rem;
  }

  .status-count-container .status-count-label {
    font-weight: 500;
    letter-spacing: 0.8px;
    text-transform: uppercase !important;
    color: #727272;
  }

  .status-count-container .status-count-value {
    color: #f2f2f2;
  }

  a.item-link {
    /* color: #f2f2f2; */
    text-decoration: none;
  }

  a.item-link:hover {
    text-decoration: underline;
  }

  .location-sys-admin-notifications {
    color: #FF9D29;
    border: 1px solid #FF9D29;
    border-radius: 4px;
  }

  .location-sys-admin-notifications .action-title {
    font-size: 1.14rem;
    font-weight: 500;
  }

  .location-sys-admin-notifications .action-info {
    font-size: 1.0rem;
    color: #9c9c9c;
  }

  .location-sys-admin-notifications .more-info-text {
    color: #ffffff;
  }
</style>
